import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { VehiclePhotosPage } from './vehicle-photos.page';

const routes: Routes = [
  {
    path: '',
    component: VehiclePhotosPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VehiclePhotosPageRoutingModule {}
